import React, { useEffect, useRef, useState } from "react";
import { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { useRecoilState } from "recoil";
import { useApi } from "../../../hooks/useApi";
import Blank from "../../DefaultStyles/Blank";
import Loader from "../../DefaultStyles/Loader";
import { Input } from "../../Input/Input";
import { Textarea } from "../../Input/Textarea";
import AlertModal from "../../Modal/AlertModal";
import DefaultModalLayout, {
  defaultModalType,
} from "../../Modal/DefaultModalLayout";
import {
  HasInitValueBox,
  ModalRowContentContainer,
} from "../AlimTalk/AlimTalkModal";
import StatusCodeBox, {
  StatusCodeBoxContainer,
} from "../AlimTalk/AlimTalkModal/StatusCodeBox";
import { ModalRow } from "../Users/UserDetail/BlackListModal/BlackListModal";
import { DeleteModalLabel } from "../Users/UserDetail/CommentModal/CommentDeleteModal";
import { DefaultModalCommonProps } from "../Users/UserDetail/CommentModal/CommentModal";
import TargetContainer, {
  ModalLabel,
} from "../Users/UserDetail/CommentModal/TargetContainer";

interface LmsModalProps extends DefaultModalCommonProps {
  viewData?: {
    sender?: string;
    title?: string;
    user: string;
    id?: string;
    sendTime?: string;
  };
  isSubPhone?: boolean;
  lmsDetail?: AxiosResponse;
}

export default function LmsModal({
  closeEvent,
  confirmEvent,
  type,
  viewData,
  isSubPhone,
  lmsDetail,
}: LmsModalProps) {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  const [modalType, setModalType] = useRecoilState(defaultModalType);

  const lmsDetailResponse = lmsDetail;

  const [targetUid, setTargetUid] = useState(viewData?.user ?? "");
  const [title, setTitle] = useState(viewData?.title ?? "");
  const [body, setBody] = useState("");
  const [sendAskModal, setSendAskModal] = useState(false);
  const [sendLms, setSendLms] = useState(false);
  const [status, setStatus] = useState({
    api: "",
    sms: "",
  });

  // lms 보내기
  const {
    response: sendResponse,
    error: sendError,
    loading: sendLoading,
  } = useApi({
    method: "post",
    url: sendLms ? `kakao/lms` : undefined,
    data: {
      uid: Number(targetUid?.split("_")[0]),
      title,
      message: body,
      isSubPhone: isSubPhone ? 1 : 0,
    },
  });

  console.log(viewData);
  console.log(targetUid);

  const fnChkByte = (value: string, maxByte: number) => {
    let str = value ?? "";
    let str_len = str.length;

    let rbyte = 0;
    let rlen = 0;
    let one_char = "";
    let str2 = "";

    for (let i = 0; i < str_len; i++) {
      one_char = str.charAt(i);
      if (escape(one_char).length > 4) {
        rbyte += 2; //한글2Byte
      } else {
        rbyte++; //영문 등 나머지 1Byte
      }
      if (rbyte <= maxByte) {
        rlen = i + 1; //return할 문자열 갯수
      }
    }

    if (rbyte > maxByte) {
      // alert("한글 "+(maxByte/2)+"자 / 영문 "+maxByte+"자를 초과 입력할 수 없습니다.");
      //   alert("메세지는 최대 " + maxByte + "byte를 초과할 수 없습니다.");
      str2 = str.substr(0, rlen); //문자열 자르기
      value = str2;
      fnChkByte(value, maxByte);
    }
  };

  // 알림톡 보내기
  useEffect(() => {
    if (sendResponse?.status === 201) {
      setSendAskModal(false);

      if (confirmEvent) {
        confirmEvent();
      } else {
        closeEvent();
      }

      toast.success(sendResponse?.data?.result ?? "", {});
    }
  }, [sendResponse]);

  useEffect(() => {
    if (sendError) {
      setSendAskModal(false);
      setSendLms(false);

      toast.error(
        sendError.data ?? sendError.data[0] ?? "LMS 보내기에 실패했습니다."
      );
    }
  }, [sendError]);

  useEffect(() => {
    if (type) {
      setModalType(type);
    }

    if (type === "input") {
      setBody(
        `안녕하세요, ${
          targetUid?.includes("_")
            ? `${targetUid?.split("_")[1]}(${targetUid?.split("_")[2]})님.\n`
            : ``
        }링키드 고객센터입니다.\n\n관련하여 문의사항이 있을 경우, 링키드 고객센터로 연락주세요.\n링키드 고객센터: https://linkid.pw/help/chat\n\n감사합니다.\n링키드 드림.`
      );
    }
  }, [type, targetUid]);

  useEffect(() => {
    if (textareaRef && textareaRef.current) {
      textareaRef.current.style.height = "0px";
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = scrollHeight + "px";
    }
  }, [body]);

  useEffect(() => {
    if (lmsDetailResponse?.data) {
      setBody(lmsDetailResponse?.data?.message);
      setStatus({
        sms: lmsDetailResponse?.data?.sms_status,
        api: lmsDetailResponse?.data?.status,
      });
    }
  }, [lmsDetailResponse]);

  return (
    <DefaultModalLayout
      closeEvent={() => closeEvent()}
      cancelBtn={type === "input" ? undefined : <></>}
      confirmEvent={() => {
        if (type === "input") {
          setSendAskModal(true);
        } else {
          closeEvent();
        }
      }}
      confirmDisabled={!targetUid?.split("_")[0] || title === "" || body === ""}
      confirmBtnText={modalType === "input" ? "확인" : "닫기"}
      modalTitle={
        type === "input"
          ? isSubPhone
            ? "LMS 보내기(보조 연락처)"
            : "LMS 보내기"
          : "LMS 조회"
      }
      leftBottomName={type === "input" ? undefined : viewData?.sender ?? ""}
      leftBottomTitle={type === "input" ? undefined : "작성자"}
      leftBottomTime={type === "input" ? undefined : viewData?.sendTime}
    >
      {/* 대상 */}
      <ModalRow>
        {type === "input" ? (
          <TargetContainer
            targetUid={targetUid}
            setTargetUid={setTargetUid}
            modalType={modalType}
            isFlexStart={true}
            inputBoxWidth={330}
          />
        ) : (
          <ModalRow>
            <ModalLabel>대상</ModalLabel>

            <ModalRowContentContainer>
              <HasInitValueBox style={{ width: 330 }}>
                {targetUid}
              </HasInitValueBox>
            </ModalRowContentContainer>
          </ModalRow>
        )}
      </ModalRow>

      {/* 제목 */}
      <ModalRow>
        <ModalLabel>제목</ModalLabel>

        <ModalRowContentContainer>
          <Input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            type="text"
            placeholder="직접 입력(20 byte)"
            maxLength={10}
            disabled={viewData?.title ? true : false}
          />
        </ModalRowContentContainer>
      </ModalRow>

      {/* 내용 */}
      <DeleteModalLabel>내용</DeleteModalLabel>

      {lmsDetailResponse?.data?.message ? (
        <StatusCodeBoxContainer
          style={{
            marginBottom: 20,
            whiteSpace: "pre-line",
            lineBreak: "anywhere",
          }}
        >
          {body}
        </StatusCodeBoxContainer>
      ) : (
        <Textarea
          ref={textareaRef}
          placeholder="내용 입력(2000 byte)"
          onChange={(e) => setBody(e.target.value)}
          value={body}
          onKeyUp={(e) => {
            const value = (e.target as HTMLInputElement).value;
            fnChkByte(value, 2000);
          }}
          maxLength={1000}
          readOnly={lmsDetailResponse?.data?.message}
          style={{ maxHeight: 290 }}
        />
      )}

      {/* 상태 코드 */}
      <>
        {modalType !== "input" && (
          <>
            <Blank blankHeight={20} />

            <DeleteModalLabel>상태 코드</DeleteModalLabel>

            <StatusCodeBox status={status} />
          </>
        )}

        {sendAskModal && (
          <AlertModal
            title={"LMS를 보내시겠습니까?"}
            btnColor="mint"
            cancelEvent={() => setSendAskModal(false)}
            confirmEvent={() => setSendLms(true)}
          />
        )}

        {sendLoading && <Loader />}
      </>
    </DefaultModalLayout>
  );
}
